const translation = {
  usePersonalInfo: "개인정보 수집 및 이용 동의",
  essential: "필수",


}

export { translation }